import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchExportacoes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('exportacoes', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchExportacao(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`exportacoes/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }
  },
}
